export interface CreditCardIconProps {
  color?: string;
  className?: string;
}

/**
 * お支払いの面に使うカード。
 *
 * 書類のアイコンを使っていたが、請求書にも規約にも読めて、支払いだと
 * 分からなかった。線の太さと既定色は FileTextIcon に合わせてある。
 */
export function CreditCardIcon({
  color = "#AEADA9",
  className,
}: CreditCardIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="2"
        y="5"
        width="20"
        height="14"
        rx="2"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* 磁気ストライプ。これが無いと、ただの角丸の箱に見える */}
      <path
        d="M2 10h20"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 15h4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
